var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_646cdaea"]},_vm.$listeners),[_c('cube-divider',{attrs:{"position":"left"}},[_c('div',{class:["divider-slot"]},[_vm._v("This is slot text")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }